export default __webpack_public_path__ + "static/media/36_back.100ec136.png";